import { Icon } from './Icon'
import type { Meta } from '../types'
import type { PageKey } from './Sidebar'

const titles: Record<PageKey, { title: string; subtitle: string }> = {
  dashboard: { title: '资源总览', subtitle: '免费云额度优先，本地服务器按需接管' },
  nodes: { title: '服务器节点', subtitle: '实时容量、运行状态与可安装能力' },
  resources: { title: '云资源与 API', subtitle: '集中管理 AWS、Azure、Google、Oracle、阿里云国际站与自建资源' },
  services: { title: '智能分流', subtitle: '按额度、到期时间和健康状态自动选择服务出口' },
  domains: { title: '域名与入口', subtitle: 'Cloudflare DNS、Nginx 反向代理和证书任务' },
  terminal: { title: '安全终端', subtitle: '白名单命令、任务状态与完整审计' },
  docs: { title: '安装与接入', subtitle: '节点 Agent、统一 Gateway 和 OpenAPI' },
}

export function TopBar({ page, loading, meta, onRefresh, onMenu, onToken }: { page: PageKey; loading: boolean; meta: Meta | null; onRefresh: () => void; onMenu: () => void; onToken: () => void }) {
  const heading = titles[page]
  const refreshMinutes = Math.max(1, Math.round((meta?.provider_refresh_interval_seconds || 300) / 60))
  return <header className="topbar">
    <div className="topbar-heading">
      <button className="mobile-menu icon-button" onClick={onMenu} aria-label="打开导航"><Icon name="menu" /></button>
      <div><div className="breadcrumb"><span>TIANCLOUD</span><span>/</span><span>{heading.title}</span></div><h1>{heading.title}</h1><p>{heading.subtitle}</p></div>
    </div>
    <div className="topbar-actions">
      <span className="topbar-automation"><span className="live-dot" /><span>自动同步 · {refreshMinutes} 分钟</span></span>
      {meta?.demo_mode && <span className="environment-pill"><span />演示数据</span>}
      <button className="button button-ghost topbar-session" onClick={onToken}><Icon name={meta?.tiantian_nas?.enabled ? 'lock' : 'key'} /><span>{meta?.tiantian_nas?.enabled ? '管理员' : '令牌'}</span></button>
      <button className="button button-secondary topbar-refresh" onClick={onRefresh} disabled={loading}><Icon name="refresh" className={loading ? 'spin' : ''} /><span>{loading ? '同步中' : '立即同步'}</span></button>
    </div>
  </header>
}
